module.exports = __webpack_public_path__ + "img/mobile_pink_cloud_3.fac4dad5.svg";